// Preflight guard for claim disbursement actions.
// Returns true if current time is inside the configured window, false otherwise.
// On block, shows a swal warning with the current window (WIB).
// On fetch error (network / 4xx / 5xx), fails open (returns true) —
// BE guard in submitRefundClaim / submitRefundClaimToAggregator / ClaimRefund
// is the authoritative check.

import apiService from '@/services/apiService';

const toMinutes = (hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  return (h * 60) + m;
};

const getNowMinutesWIB = () => {
  const nowWib = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' }),
  );
  return (nowWib.getHours() * 60) + nowWib.getMinutes();
};

export const disbursementTimeGuard = {
  methods: {
    async checkDisbursementTime() {
      let setting;
      try {
        const response = await apiService.get('cx/claim-setting/disbursement-time');
        setting = response.data && response.data.data;
      } catch (e) {
        console.warn('[disbursementTimeGuard] fetch failed, falling back to BE guard', e);
        return true;
      }

      if (!setting || !setting.start_time || !setting.end_time) {
        console.warn('[disbursementTimeGuard] setting missing or malformed, falling back to BE guard', setting);
        return true;
      }

      const nowMin = getNowMinutesWIB();
      const startMin = toMinutes(setting.start_time);
      const endMin = toMinutes(setting.end_time);

      if (nowMin >= startMin && nowMin <= endMin) return true;

      this.$swal({
        type: 'warning',
        title: 'Di luar jam operasional',
        text: `Pencairan dana hanya dapat dilakukan di jam operasional (${setting.start_time} – ${setting.end_time} WIB).`,
        confirmButtonText: 'OK',
      });
      return false;
    },
  },
};

export default disbursementTimeGuard;
